import { Field } from '../Field';

type ContactFieldsProps = {
    firstName?: string;
    lastName?: string;
    email?: string;
    telephoneNumber?: string;
    mobilePhoneNumber?: string;
    position?: string;
};
const ContactFields = ({
    firstName,
    lastName,
    email,
    telephoneNumber,
    mobilePhoneNumber,
    position,
}: ContactFieldsProps) => {
    return (
        <>
            <Field label="First Name" value={firstName} />
            <Field label="Last Name" value={lastName} />
            <Field label="Email Address" value={email} />
            <Field label="Telephone Number" value={telephoneNumber} />
            <Field label="Mobile Number" value={mobilePhoneNumber} />
            <Field label="Position" value={position} />
        </>
    );
};

export default ContactFields;
